import React from 'react';
import { Children, IPropsWithClassName } from 'interfaces';
import { ReactComponent as InfoIcon } from '@icons/info.svg';

import styles from './styles';
import InfoType from './type';

export interface InfoProps extends IPropsWithClassName {
  message: Children,
  type?: InfoType
}

const Info = ({
  message,
  type = InfoType.INFO,
  className,
  ...props
}: InfoProps) => {
  const componentStyles = styles.component(className, type);

  return (
    <div
      className={componentStyles}
      {...props}
    >
      <InfoIcon />
      <span className={styles.message}>{message}</span>
    </div>
  );
};

export default Info;
